export default {"src":"/_next/static/media/LAMR.67d41f79.svg","height":18,"width":18};